import {type FC, useEffect} from 'react';
import Streaming from '../stream/component/Streaming.tsx';
import VodPlayer from '../stream/component/VodPlayer.tsx';
import NoStreaming from '../stream/component/NoStreaming.tsx';
import {isBroadcastOver} from '../../utils/StreamingUtil.ts';
import {getTodayEvents} from '../../utils/DateUtil.ts';
import TimelineBar from '../stream/component/TimelineBar.tsx';
import useStreamingStore from '../../store/useStreamingStore.ts';
import {WatchingWrapper} from './types/Watching.styled.ts';
import callApi from '../../apis/callApi.ts';
import useCenterStore from '../../store/useCenterStore.ts';

const Watching: FC = () => {
    const {scheduledData, setScheduledData, streamingPollingData, setJitsiToken, setStreamingState} =
        useStreamingStore();
    const {centerInfo, getCenterInfo, allDevices, setAllDevices} = useCenterStore();

    useEffect(() => {
        getCenterInfo('test');
    }, []);

    useEffect(() => {
        if (!centerInfo?.center_id) return;

        const fetchData = async () => {
            try {
                const {data} = await callApi().get('/tvs/schedule/client/');
                setScheduledData(getTodayEvents(data.slides));

                const token = await setJitsiToken(centerInfo.center_id);
                setStreamingState({jwt: token});

                if (allDevices.length < 3) {
                    await setAllDevices();
                }
            } catch (error) {
                console.error('fetchData failed:', error);
            }
        };

        fetchData();
    }, [centerInfo?.center_id]);

    return (
        <WatchingWrapper>
            {/* 방송이 있을 경우 (스트리밍) */}
            {streamingPollingData && streamingPollingData.broadcast.content_type === 'live' && <Streaming />}

            {/* 방송이 있을 경우 (VOD) */}
            {streamingPollingData && streamingPollingData.broadcast.content_type === 'vod' && (
                <VodPlayer
                    videoUrl={streamingPollingData.broadcast.vod!.video}
                    startTime={streamingPollingData.broadcast.start_time}
                    endTime={streamingPollingData.broadcast.end_time}
                />
            )}

            {/* 방송이 없을 경우 */}
            {streamingPollingData && streamingPollingData.broadcast.content_type === null && <NoStreaming />}
        </WatchingWrapper>
    );
};

export default Watching;
